import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';

export default withStyles((theme) => ({
  root: {
    paddingTop: '20px',
    [theme.breakpoints.down('xs')]: {
      //paddingBottom: '80px'
    }
  }
}))(Container);
